import { User } from "../types";
import { getAuthErrorMessage, isDeletedUserError } from "../utils/authErrors";
import { baseFetch } from "./base";

export const verifyToken = async (
  token: string,
): Promise<{ valid: boolean; message?: string }> => {
  try {
    const response = await baseFetch.post("/verify", { token });
    return { valid: true, message: response.data.message };
  } catch (error: unknown) {
    if (isDeletedUserError(error)) {
      return {
        valid: false,
        message: getAuthErrorMessage(error),
      };
    }
    console.error("Error verifying token:", error);
    throw error;
  }
};

export const authorizeUser = async (
  username: string,
  password: string,
): Promise<{
  valid: boolean;
  message?: string;
  token?: string;
  user?: User;
}> => {
  try {
    const response = await baseFetch.post(
      "/authorization",
      {
        username,
        password,
      },
      {
        headers: {
          "No-Auth": true,
        },
      },
    );
    return {
      valid: response.data.valid,
      message: response.data.message,
      user: response.data.user,
      token: response.data.token,
    };
  } catch (error: any) {
    if (error.response && error.response.status === 401) {
      return {
        valid: false,
        message: error.response.data.detail,
        user: undefined,
      };
    }
    console.error("Error authorizing user:", error);
    throw error;
  }
};

export const updatePassword = async (
  newPassword: string,
  temporaryToken: string,
): Promise<void> => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/update_password`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${temporaryToken}`,
        },
        body: JSON.stringify({ new_password: newPassword }),
      },
    );
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("Update password error:", errorData);
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error: any) {
    console.error("Error in updatePassword fetch:", error);
    throw error;
  }
};
